import React from 'react';
import { BackDropWrapperType } from './types';
import styles from './wrapper.module.scss';
import { CircularLoader } from '../../components/Loader';
import { Backdrop } from '@mui/material';

const BackDropLoader: React.FC<BackDropWrapperType> = ({ children, loading, className }) => (
  <div className={styles.backdropContainer}>
    <Backdrop
      open={loading}
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      className={className ? className : styles.backdropLoader}
    >
      <CircularLoader size={32} color={'primary.dark'} />
    </Backdrop>
    {children}
  </div>
);
export default BackDropLoader;
